import Image from 'next/image';
import { Hero } from "@/lib/aboutPage";
import Link from 'next/link';

const AboutHero = () => {
  return (
    <section
      className="relative h-[85vh] min-h-[500px] lg:h-[100vh] w-full overflow-hidden flex items-center bg-black"
      aria-labelledby="hero-heading"
    >
      {/* 1. Background Image - Optimized for LCP */}
<div className="absolute inset-0 z-0">
  <Image
    src={Hero.imageUrl}
    alt=""
    fill
    priority
    fetchPriority="high"
    quality={85}
    sizes="100vw"
    className="object-cover object-center pointer-events-none"
  />

  {/* 2. Bottom-to-Top Black Overlay */}
  {/* 'bg-gradient-to-t' starts the color at the bottom and fades towards the top */}
  <div
    className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/20"
    aria-hidden="true"
  />

  {/* 3. Optional: Extra Darkening for Text Readability (Left-to-Right) */}
  <div
    className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-transparent"
    aria-hidden="true"
  />
</div>

      {/* 3. Content Container */}
      <div className="relative z-10 mx-auto max-w-7xl w-full px-6 sm:px-10 md:px-12 lg:px-16">
        <header className="max-w-4xl text-left text-white">

          {/* Subtext - Semantic span for SEO */}
          <span className="mb-3 block text-[11px] sm:text-xs md:text-sm font-bold uppercase tracking-[0.2em] text-blue-400">
            {Hero.subtitle}
          </span>

          {/* H1: Primary SEO Signal */}
          <h1
            id="hero-heading"
            className="mb-4 sm:mb-6 text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold tracking-tight leading-[1.1]"
          >
            {Hero.title}
          </h1>

          {/* Description - Optimized contrast and readability */}
          <p className="mb-8 md:mb-10 max-w-xs sm:max-w-md md:max-w-xl lg:max-w-2xl text-sm sm:text-base md:text-lg lg:text-xl text-gray-100 leading-relaxed font-medium">
            {Hero.description}
          </p>

          {/* Responsive CTA */}
          <div className="flex flex-wrap gap-4 justify-start">
            <Link
              href="/contact"
              aria-label="Contact us for more information"
              className="group relative inline-flex items-center justify-center rounded-full bg-[#4F7AC2] px-7 sm:px-10 py-3.5 sm:py-4 text-sm sm:text-base font-bold text-white transition-all duration-300 hover:bg-blue-500 hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-400 active:scale-95 shadow-xl shadow-blue-500/20"
            >
              <span>{Hero.ctaButton}</span>
              <svg
                className="ml-2 h-5 w-5 transition-transform duration-300 group-hover:translate-x-1.5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </Link>
          </div>
        </header>
      </div>
    </section>
  );
};

export default AboutHero;